import type { ReactElement } from 'react'
import type { IAppSummary } from '~/types/application'

import { VersionArchiveEngine } from '../Engines'

import { ENGINE_TYPE } from '~/types/arbitration'

interface Props {
  selectedApp: IAppSummary
}

const ArchiveEngine = ({ selectedApp }: Props): ReactElement => (
  <VersionArchiveEngine engineType={ENGINE_TYPE.ARCHIVE} selectedApp={selectedApp} />
)

export default ArchiveEngine
